import React, { useEffect, useState } from 'react';

import { Chart, Series,Tooltip,Format} from 'devextreme-react/chart';
import CardQuick from '../../components/Card';
import { Box, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Legend } from 'devextreme-react/pie-chart';
import { dashboardService } from '../../services';

const MovementsChart = ({ locationId }) => {
    const navigate = useNavigate()
    const [data, setData] = useState([]);
    useEffect(() => {
        dashboardService.getCurrentAccountMovements(locationId).then((data) => {
            setData(data);
        }).catch(() => {

        })
    }, [locationId])
    return (
        <Box>
            <Typography variant="h3">Conta Corrente</Typography>
            <CardQuick>
                <Chart id="chart" dataSource={data}
                    style={{ height: '250px' }}
                >
                    <Series
                        valueField="total"
                        argumentField="Month"
                        type="bar"
                        color="#BF2F38"
                    />
                    <Legend visible={false}>

                    </Legend>
                    <Tooltip enabled={true}>
                        <Format type="fixedPoint" />
                    </Tooltip>
                </Chart>
            </CardQuick>
            <Box sx={{ borderBottomLeftRadius: 4, borderBottomRightRadius: 4 }} bgcolor={'#ececec'}>
                <Button onClick={() => {
                    navigate('/current-account');
                }} sx={{ margin: '8px' }} variant="contained" color="secondary2">Ver Conta corrente</Button>

            </Box>
        </Box>


    );
}
export default MovementsChart;
